import axios from "axios";
import {campaignConfig} from "@/config";

export default class CampaignService {
    static async getCampaignConfig(campaignId) {
        try {
            const response = await axios.post(`${campaignConfig.host}/campaign/get-campaign-config`, {
                campaignId: campaignId,
            });
            return response.data;
        } catch (e) {
            return {authError: true};
        }
    }
}
